import { BridgeComponent } from "@hotwired/hotwire-native-bridge";
class Search extends BridgeComponent {
    static component = "search";

    connect() {
        super.connect();

        this.lastQuery = "";
        this.debounceTimer = null;

        this.send("connect", {}, (message) => {
            const query = message.data?.query?.trim();
            if (!query || query.length < 2) return;

            clearTimeout(this.debounceTimer);

            this.debounceTimer = setTimeout(() => {
                this.performRedirect(query);
            }, 600);
        });
    }

    performRedirect(query) {
        sessionStorage.setItem("redirectedQuery", query);
        const searchUrl = `${wkhw_customForm.site_url}/?s=${encodeURIComponent(
            query,
        )}&post_type=product`;
        window.location.href = searchUrl;
        if (!wkhw_customForm.is_android) {
            setTimeout(() => {
                window.location.reload();
            }, 100);
        }
    }
}
export default Search;
